import { type LucideProps } from 'lucide-react'

export default function YepCode(props: LucideProps) {
  return (
    <svg
      width='26'
      height='26'
      viewBox='0 0 26 26'
      fill='none'
      xmlns='http://www.w3.org/2000/svg'
      {...props}
    >
      <g id='959458f5'>
        <path
          id='bbb36f40'
          d='M25.3102 4.78822C25.3102 4.78822 25.3102 4.83117 25.3102 4.78822C25.3102 4.83117 25.3102 4.83117 25.3102 4.78822L20.9324 9.21143C20.3315 9.81264 19.3444 9.81264 18.7435 9.21143L16.5547 7.0213C15.9538 6.42009 15.9538 5.47532 16.5547 4.87411L20.9324 0.450909C21.5333 -0.150303 22.5204 -0.150303 23.1213 0.450909L25.3102 2.64104L25.3531 2.68398C25.911 3.24225 25.911 4.18701 25.3102 4.78822Z'
          fill='currentColor'
        ></path>
        <path
          id='25b03c28'
          d='M16.4279 14.012L12.9859 17.421L5.02895 25.3014C4.40312 25.9212 3.37498 25.9212 2.74916 25.3014L0.469369 23.0435C-0.156456 22.4237 -0.156456 21.4497 0.469369 20.7856L7.30874 14.012C7.93456 13.3922 7.93456 12.374 7.30874 11.7542L0.469369 4.98059C-0.156456 4.36078 -0.156456 3.3868 0.469369 2.76699L0.51407 2.72272L2.79386 0.464855C3.41969 -0.154952 4.44783 -0.154952 5.07365 0.464855L13.0753 8.38952L16.5173 11.7985C17.0537 12.374 17.0537 13.3922 16.4279 14.012Z'
          fill='currentColor'
        ></path>
      </g>
    </svg>
  )
}
